export function of(promise) {
    return Promise.resolve(promise)
        .then(function (result) { return [result]; })
        .catch(function (err) {
        if (typeof err === 'undefined') {
            err = new Error('Rejection with empty value');
        }
        return [undefined, err];
    });
}
